/* eslint-disable react/no-direct-mutation-state */
// 设置展开栏群成员

import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./index.less";
import { Input } from "antd";
import classNames from "classnames";
import { ChatMessage, ChatMessageType, GroupRoster, MessageStatus } from "@/types/chat/";
import { useTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import PinyinMatch from "pinyin-match";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import GroupMemberOperate from "@/components/chat/GroupMembers/MemberOperate";
import useGroupUserSelector from "@/components/chat/GroupUserSelector";
import { checkCanAddMember, isGroupOrdinary } from "@/utils/chat/group";
import Context from "@/components/chat/context";
import { getGroupMemberList } from "@/api/chat";
import _ from "lodash";
import { GroupAttribute } from "@jd/jdee.im.sdk/lib/es/model/Group";
import bus from "@/utils/bus";
import ScrollView from "@/baseComponents/ScrollView";
import Loading from "@/components/Loading";
import { usePrevious } from "@/utils/chat/index";
import { analysisLog } from "@/utils/logAnalytics";
import { isBannedPostGroupSession, isShowAlias } from "@/utils/chat/message";
import MemberCustomAreaExtra from "@/components/chat/message/InviteForward/MemberCustomAreaExtra";
import ImService from "@/server/ImService";
import { mapInviteStranger } from "../GroupUserSelector/common";
import { isFocusEnv } from "@/utils";

interface GroupMembersProps {
  updateGroupMembers: Function;
}

function GroupMembers(props: GroupMembersProps & ChatState) {
  const { selectedSession, sessionMessages } = props;
  const prevSessionId = usePrevious(selectedSession?.sessionId || "");
  const { currentEmployee, groupRosterIdentity, userData } = React.useContext(Context);
  const { t } = useTranslation("chat");
  const currId = React.useRef("");
  const [groupRosters, setGroupRosters] = useState<GroupRoster[]>([]);
  const [list, setList] = useState([] as Partial<GroupRoster>[]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");

  const [activeKey, setActiveKey] = useState(1);
  const [showTab, setShowTab] = useState(false);
  const [currentList, setCurrentList] = useState([] as any);
  const [invitedList, setInvitedList] = useState([] as any);
  const getAllGroupMembers = React.useCallback(
    (gid: string) => {
      if (!gid) {
        return;
      }
      if (!groupRosters?.length) {
        setLoading(true);
      }
      getGroupMemberList(gid, "group", selectedSession)
        .then(({ data, groupId }) => {
          if (groupId === currId.current) {
            setGroupRosters(data);
            setLoading(false);
          }
        })
        .catch((e) => {
          console.log("getGroupMemberList--err", e);
        });
    },
    [selectedSession, groupRosters?.length]
  );

  const getInvitedList = useCallback(async () => {
    const strangerList = await mapInviteStranger(selectedSession?.sessionId);
    if (!strangerList || strangerList.length === 0) {
      setInvitedList([]);
      setShowTab(false);
      setActiveKey(1);
      return;
    }
    setShowTab(true);
    setInvitedList(strangerList);
  }, [selectedSession?.sessionId]);

  useEffect(() => {
    getInvitedList();
    bus.on(`chat:session-update:${selectedSession?.sessionId}`, () => {
      console.log('邀请后更新～～～');
      getAllGroupMembers(selectedSession.sessionId);
    });
    bus.on("chat:invitedList-update", () => {
      getInvitedList();
    });
    return () => {
      bus.off(`chat:session-update:${selectedSession?.sessionId}`);
      bus.off("chat:invitedList-update");
    };
  }, [selectedSession.sessionId, getAllGroupMembers, getInvitedList]);

  // todo 先hack，需要查找selectedSession rosters 的赋值时机
  useEffect(() => {
    if (prevSessionId && prevSessionId === selectedSession.sessionId) {
      return;
    }
    let groupInfo = selectedSession.info as GroupAttribute;
    // 解散群或者不在群不调用接口
    if (!groupInfo.gid || groupInfo.status === 0 || (groupInfo.flag && groupInfo.flag !== 3)) {
      return;
    }
    getAllGroupMembers(groupInfo.gid);
    currId.current = selectedSession.sessionId;
  }, [selectedSession, getAllGroupMembers, prevSessionId]);

  useEffect(() => {
    if (groupRosters) {
      setList(groupRosters);
      setCurrentList(groupRosters);
    }
  }, [groupRosters]);

  useEffect(() => {
    if (activeKey === 1) {
      setCurrentList(list);
    } else if (activeKey === 2) {
      setCurrentList(invitedList);
    }
  }, [invitedList, activeKey, list]);

  // input框enter搜索事件
  const searchName = useCallback(
    (e: any) => {
      let addTagList: any[] = invitedList.map((item: any) => {
        return {
          ...item,
          invitedTag: true
        };
      });
      const searchList = [...groupRosters, ...addTagList];
      const value = e.target.value;
      setKeyword(value);
      setShowTab(false);
      if (!value) {
        if (invitedList.length) {
          setShowTab(true);
        }
        if (activeKey === 2) {
          setCurrentList(invitedList);
          return;
        }
        setCurrentList(groupRosters);
        setActiveKey(1);
        return;
      }
      const result = searchList.filter((s) => {
        const info: any = s.user || {};
        const condition =
          PinyinMatch.match(info.nickName || info.name || "", value) ||
          PinyinMatch.match(info.unitName || "", value) ||
          PinyinMatch.match(info.deptName || "", value) ||
          PinyinMatch.match(info.titleName || "", value) ||
          PinyinMatch.match(info.remark || "", value);
        if (isShowAlias(selectedSession)) {
          return condition || PinyinMatch.match(s?.alias || "", value);
        } else {
          return condition;
        }
      });
      setCurrentList(result);
    },
    [activeKey, groupRosters, invitedList, selectedSession]
  );

  const searchPart = useMemo(() => {
    if (!groupRosters?.length) {
      return null;
    }
    return (
      <div className="members_search">
        <Input
          value={keyword}
          onChange={searchName}
          onFocus={() => analysisLog("Xtbg_Msg_Setting", "SearchMember")}
          placeholder={
            isShowAlias(selectedSession)
              ? "搜索姓名、昵称、单位、部门或职务"
              : "搜索姓名、单位、部门或职务"
          }
          prefix={<IconFont type="iconic_search" className="search-icon" />}
        />
      </div>
    );
  }, [groupRosters, searchName, selectedSession, keyword]);

  const filterSessionMessages = useCallback(() => {
    if (!sessionMessages) {
      return [];
    }
    const messageTyps = [
      ChatMessageType.IMAGE,
      ChatMessageType.FILE,
      ChatMessageType.EGOV_FILE,
      ChatMessageType.TEXT,
      ChatMessageType.VIDEO,
      ChatMessageType.VOICE,
      ChatMessageType.JOYSPACEFILE,
      ChatMessageType.TEMPLATE2,
      ChatMessageType.LOCATION_JD
    ];
    return sessionMessages.filter((item) => {
      let flag = true;
      if (!messageTyps.includes(item.type)) {
        flag = false;
        return flag;
      }
      if (item.revoke === 1) {
        flag = false;
        return flag;
      }
      if (item.type === "file") {
        flag = item.status === MessageStatus.SUCCESS || item.statusType === MessageStatus.SUCCESS;
        if (!flag) return flag;
      }
      if (
        item.statusType === MessageStatus.FAILED ||
        item.statusType === MessageStatus.SENDING ||
        item.statusType === MessageStatus.EXPIRED
      ) {
        flag = false;
        return flag;
      }
      if ((item as any).role === 1 || item.plusList?.length) {
        flag = false;
        return flag;
      }
      if (item.fuuid) {
        flag = false;
        return flag;
      }
      return flag;
    });
  }, [sessionMessages]);

  useEffect(() => {
    console.log("currentList:", currentList);
  }, [currentList]);

  const searchMessages = useCallback(async () => {
    const filterMessages = filterSessionMessages().slice(-20) || [];
    const needSearch = filterMessages.length < 20 && filterMessages.length > 0;
    const imService = ImService.getInstance();
    let messages: any[] = [];
    if (needSearch) {
      messages = await imService.search({
        sessionId: selectedSession.sessionId,
        searchKey: "",
        desc: true,
        includeBurnAfterRead: true,
        excludeInviteForward: true,
        excludeExpiredMsg: true,
        excludeFailedMsg: true,
        excludeAggregationMsg: true,
        excludeAggregationChildMsg: true,
        excludeGroupNotice: true,
        queryType: 2,
        startMid: filterMessages[0]?.mid
          ? isFocusEnv()
            ? filterMessages[0]?.mid
            : filterMessages[0]?.mid - 1
          : -1,
        limit: 20 - filterMessages.length,
        findTimestamp: filterMessages[0]?.timestamp
      });
    }
    messages = [...messages, ...filterMessages];
    const list: ChatMessage[] = messages.sort(
      (a: any, b: any) => a.timestamp - b.timestamp
    ) as ChatMessage[];
    return list;
  }, [selectedSession.sessionId, filterSessionMessages]);

  const isBanned = useMemo(() => {
    return isGroupOrdinary(groupRosterIdentity) && isBannedPostGroupSession(selectedSession);
  }, [groupRosterIdentity, selectedSession]);

  const addMembers = useGroupUserSelector({
    selectedSession,
    currentEmployee,
    groupRosters,
    sessionMembers: [],
    userData,
    customAreaExtra: !isBanned && (
      <MemberCustomAreaExtra
        selectedSession={selectedSession}
        messages={[]}
        searchMessages={searchMessages}
      />
    )
  });

  const canAddMember = useMemo(() => {
    return checkCanAddMember({ selectedSession, groupRosterIdentity });
  }, [selectedSession, groupRosterIdentity]);

  const addMembersPart = useMemo(() => {
    if (!list || !list.length) {
      return null;
    }
    if (!canAddMember) {
      return null;
    }
    return (
      <div className="icon-box">
        <div
          className="icon-part"
          onClick={addMembers}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|AddMember"
        >
          <IconFont type="iconapp_btn_add2" />
          <span>{t("add_member")}</span>
        </div>
      </div>
    );
  }, [addMembers, canAddMember, t, list]);

  const getClassName = useCallback(
    (key: number) => {
      if (key === activeKey) {
        return "member_hover member_active";
      } else {
        return "member_hover";
      }
    },
    [activeKey]
  );

  const getItemClasses = useCallback((item: any) => {
    return classNames({
      independent: true,
      pad: !item.info
    });
  }, []);

  return (
    <div className="group-members">
      {selectedSession.isGroup && (
        <div className="group-in">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%"
              }}
            >
              <Loading />
            </div>
          ) : (
            <>
              <div className="members_head">
                <div className="members">
                  {t("group_members")}({groupRosters?.length || 0})
                </div>
                {addMembersPart}
              </div>
              {searchPart}
              <div className="member_category">
                {showTab && (
                  <div
                    className={getClassName(1)}
                    onClick={() => {
                      setActiveKey(1);
                    }}
                  >
                    已入群
                  </div>
                )}
                {showTab && (
                  <div
                    className={getClassName(2)}
                    onClick={() => {
                      setActiveKey(2);
                    }}
                  >
                    待入群
                  </div>
                )}
              </div>
              <ScrollView className="members_con scroll-view" nohorizontal="true">
                {currentList?.map((item: any, index: any) => {
                  return (
                    <div className={getItemClasses(item)} key={index}>
                      {item?.info && (
                        <GroupMemberOperate
                          member={item}
                          getAllGroupMembers={getAllGroupMembers}
                          keyword={keyword}
                          canAddMember={canAddMember}
                        />
                      )}
                    </div>
                  );
                })}
              </ScrollView>
            </>
          )}
        </div>
      )}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, sessionMessageMap } = chat as ChatState;
  const sessionMessages: ChatMessage[] = sessionMessageMap[selectedSession.sessionId] || [];
  return { selectedSession, sessionMessages };
}
function mapDispatchToProps(dispatch: any) {
  return {
    async updateGroupMembers(data: { groupRosters: any }) {
      await dispatch({ type: "chat/updateGroupMembers", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupMembers);
